/**
 * OwnerDashboard Component
 * 오너 대시보드 UI - 준비중
 */
import React from 'react';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';

const OwnerDashboard: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-6">
      <div className="bg-white rounded-2xl shadow-lg p-12 text-center max-w-md">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-100 rounded-full mb-6">
          <WrenchScrewdriverIcon className="h-10 w-10 text-blue-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-3">준비중</h1>
        <p className="text-gray-600">
          대시보드 기능을 준비하고 있습니다.
          <br />
          빠른 시일 내에 제공해 드리겠습니다.
        </p>
      </div>
    </div>
  );
};

export default OwnerDashboard;
